<div class="stepper">
  <div class="header">
    <h1 class="font-header">{{ 'shared-components.onboarding-stepper.title' | translate }}</h1>
  </div>
  <div class="steps">
    <div
      class="step"
      [class]="'step__' + i"
      [class.active]="currentStep === i"
      *ngFor="let step of steps; index as i"
    >
      <div class="step__content" *ngIf="currentStep === i">
        <div
          class="video-container"
          *ngIf="step.type === 'video'; else imageStep"
        >
          <app-video
            [options]="{
              fluid: true,
              aspectRatio: '16:9',
              autoplay: false,
              controls: true,
              sources: [
                {
                  src: 'https://grapi.growthroad.es:5555/noauth/video?vid=intro_voc&ext=mp4',
                  type: 'video/mp4'
                }
              ]
            }"
          >
          </app-video>
        </div>
        <ng-template #imageStep>
          <img class="img-fluid" src="{{ step.src }}" alt="" />
        </ng-template>
      </div>
    </div>
  </div>
  <div class="footer">
    <button class="btn text-white bg-red" (click)="skipSteps()">{{ 'shared-components.onboarding-stepper.skip' | translate }}</button>
    <button class="btn text-white bg-red" (click)="prevStep()">{{ 'shared-components.onboarding-stepper.back' | translate }}</button>
    <button class="btn text-white bg-red" (click)="nextStep()">
      <span class="text-white" *ngIf="currentStep < maxSteps; else goToPlatform"
        >{{ 'shared-components.onboarding-stepper.next' | translate }}</span
      >
      <ng-template #goToPlatform>
        <span class="text-white">{{ 'shared-components.onboarding-stepper.go-to-platform' | translate }}</span>
      </ng-template>
    </button>
  </div>
</div>
